export const getApp = state => state.app;
export const getLocale = state => getApp(state).locale;
export const getPage = state => getApp(state).page;
export const isOffline = state => getApp(state).offline;
export const isSnackbarOpened = state => getApp(state).snackbarOpened;
export const hasWideScreen = state => getApp(state).wideScreen;
export const getClient = state => getApp(state).client;
export const getCallbackUrl = state => getApp(state).callbackUrl;
